import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { Observable } from 'rxjs'
import { filter, startWith, switchMap, tap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { RolePermissions } from '../role-permissions'
import { rolePermissionsActions } from '../role-permission.actions'
import { rolePermissionsSelectors } from '../role-permissions.selectors'
import { RequestQueryBuilder } from '@nestjsx/crud-request'

@Component({
  selector: 'role-permissions-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class RolePermissionsShowComponent implements OnInit {
  public rolePermissions$: Observable<RolePermissions>
  public rolePermissionsId$: Observable<number>
  public isLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.isLoading$ = this.store
      .select(rolePermissionsSelectors.selectIsLoading)
      .pipe(startWith(false))

    this.rolePermissionsId$ = this.store
      .select(rolePermissionsSelectors.selectIdRouteParam)
      .pipe(filter((id) => Boolean(id)))

    this.rolePermissions$ = this.rolePermissionsId$.pipe(
      tap((id) =>
        this.store.dispatch(
          rolePermissionsActions.fetchOneById({
            id,
            params: RequestQueryBuilder.create()
            //   {
            //   join: [
            //     { field: 'products' },
            //     { field: 'products.tags' },
            //     { field: 'products.location' },
            //     { field: 'products.translations' }
            //   ]
            // }
          })
        )
      ),
      switchMap((rolePermissionId) => {
        this.store.dispatch(
          BreadCrumbActions.initHistory({
            pageName: 'general.specialEvents',
            url: '/role-permissions',
            titleName: ['rolePermissionsModule.rolePermissions'],
            resourceType: 'rolePermissions',
            entityId: Number(rolePermissionId)
          })
        )
        return this.store.select(
          rolePermissionsSelectors.selectById,
          rolePermissionId
        )
      })
    )

    this.store.dispatch(
      BreadCrumbActions.addPageToHistory({
        pageName: 'rolePermissionsModule.rolePermission',
        url: null,
        titleName: ['general.specialEvents']
      })
    )
  }
}
